export const paymentByProcessorSchema = [
  {
    name: "pspCodeLocale",
    label: "Processor",
    align: "left",
    showLogo: "false",
    logoKey: "pspCode",
    logoDictKey: "pspLogoUrl",
    logoDictionary: null,
    chipColor: "#F2F1FF",
    sort: false,
  },
  {
    name: "gmvLocaleFull",
    label: "Transactional Value",
    align: "right",
  },
];

export const failureTableSchema = [
  { name: "reasonCode", label: "Reason Code", sort: false },
  { name: "reason", label: "Reason", sort: false },
  { name: "value", label: "Value" },
  { name: "count", label: "Count" },
];
